module.exports = __webpack_public_path__ + "6316123d4b99ecb122579d1305a76933.svg";